import {
  CustomTheme,
  DateAvailabilityOut,
  OrderData,
  OrderDetailsRequestData,
  SlimEventData,
  Tip,
  VoucherOut,
} from '../../api';
import { OrderPageIntent } from './OrderPageIntent';
import { SpecificEventError, VoucherError } from '../../common/OrderUtils';

export type SpecificOrderPageConfig = {
  onlyCouples?: boolean;
  onlyVouchers?: boolean;
  troubleshoot?: boolean;
  preSelectedDate?: string;
};
export type PersonalDetails = {
  firstname: string;
  lastname: string;
  alternative_full_name?: string;
  email: string;
  phone: string;
};
export type OrderPageState = {
  isInitialized: boolean;
  activeStep: number;
  account: any;
  experience: any;
  orderPage: any;
  paymentUrl: any;
  details: OrderDetailsRequestData;
  dateAndTimeDetails: {
    date: any;
    time?: any;
  };
  personalDetails: PersonalDetails;
  order_id: string;
  voucher?: VoucherOut | null;
  voucherError?: VoucherError;
  orderPageIntent: OrderPageIntent;
  theme?: CustomTheme;
  isLoadingDates: boolean;
  availableDates: DateAvailabilityOut[];
  canSpam?: boolean;
  specificOrderPage?: SpecificOrderPageConfig;
  returningCustomer: boolean;
  specificEvent?: SlimEventData | null;
  specificEventError?: SpecificEventError;
  tip?: Tip;
  orderOrVoucher?: OrderData | VoucherOut;
  returningCustomerFromOrderId?: string;
};

export const orderPageInitialState: OrderPageState = {
  isInitialized: false,
  activeStep: 0,
  account: null,
  experience: null,
  orderPage: null,
  paymentUrl: null,
  details: {
    persons: 0,
    duration: 0,
    price: 0,
    rooms: 1,
    custom_details: {},
    chosen_resources: [],
  },
  dateAndTimeDetails: {
    date: null,
    time: null,
  },
  personalDetails: {
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
  },
  order_id: '',
  voucher: undefined,
  voucherError: undefined,
  orderPageIntent: OrderPageIntent.BUY_NOW,
  theme: undefined,
  isLoadingDates: true,
  availableDates: [],
  canSpam: true,
  specificOrderPage: {
    onlyCouples: false,
    onlyVouchers: false,
    troubleshoot: false,
  },
  returningCustomer: false,
  tip: undefined,
  orderOrVoucher: undefined,
  returningCustomerFromOrderId: undefined,
};
